import { Panel } from '@/components/Panel';
import { useOverview } from '@/hooks/useOverview';
import { StatusBadge, Spinner } from '@00start/ui';

function normalizeHealthStatus(status: string): string {
  const s = status?.toLowerCase();
  if (s === 'healthy' || s === 'up' || s === 'ok') return 'resolved';
  if (s === 'degraded' || s === 'warning') return 'pending';
  return 'open';
}

function statusColorKey(status: string): string {
  const s = status?.toLowerCase();
  if (s === 'healthy' || s === 'up' || s === 'ok') return 'resolved';
  if (s === 'degraded' || s === 'warning') return 'pending';
  return 'action_req';
}

export function HealthPlanes() {
  const { data, loading } = useOverview();

  if (loading) {
    return (
      <Panel title="System Health" mobilePriority={1}>
        <div className="flex justify-center py-4"><Spinner size="sm" /></div>
      </Panel>
    );
  }

  const org = data?.health?.orgs?.[0];
  if (!org) {
    return (
      <Panel title="System Health" mobilePriority={1}>
        <p className="text-xs text-slate-500">No data</p>
      </Panel>
    );
  }

  const planes = [
    { label: 'Organ', status: org.organStatus },
    { label: 'Bridge', status: org.bridgeStatus },
    { label: 'Peer', status: org.peerStatus },
  ];

  return (
    <Panel title="System Health" mobilePriority={1}>
      <div className="grid grid-cols-3 gap-3">
        {planes.map(({ label, status }) => (
          <div key={label} className="text-center p-3 rounded-lg bg-slate-800/50">
            <div className="flex justify-center mb-1">
              <StatusBadge label={label} colorKey={statusColorKey(status)} />
            </div>
            <p className="text-[10px] text-slate-500 capitalize">{status || 'unknown'}</p>
          </div>
        ))}
      </div>
    </Panel>
  );
}
